<template>
  <div class="contain">
    <div class="inner">
      <div class="top posr">
        <!--登录-->
        <div class="login posa" v-if="userFlag">
          <!-- <span ><a :href="Link_Url.logo">登录</a></span>  -->
         <span class="jump"  @click="jump">登录</span> 
        </div>
        <div class="login posa logoi2" v-if="!userFlag">
          <span>欢迎 {{name}} !</span>
          <button @click="modal1 = true">退出</button>
        </div>
      </div>
      <div class="bottom posr">
        <!--logo-->
        <div class="logo">
          <router-link to="/home/index"><img class='posa logo' :src="Link_Url.logoUrl+topicArr.logo" alt='学校logo' >
          </router-link>
        </div>
        <!--导航栏-->
        <div class="nav ">
          <ul class="clearfix">
            <li>
              <router-link to="/home/index">招生首页</router-link>
            </li>
            <li v-for="(item,index) in tabList" :key="index">
              <router-link :to="'/home/list/'+item.id">{{item.name}}</router-link>
            </li>
          </ul>
        </div>
        <!--搜索区域-->
        <div class="search posa">
          <input type="text"
                 v-model="searchInfo"
                 @keyup.enter="search(searchInfo)"
                 placeholder="搜索你想知道的内容">
          <span class="posa" @click="search(searchInfo)"><i class="iconfont icon-sousuo"></i></span>
        </div>
      </div>
    </div>
    <!--登录框-->
    <!--提示框-->
    <Modal
      v-model="modal1"
      title="系统提示"
      @on-ok="ok"
      @on-cancel="cancel">
      <p>确定要退出吗？</p>
    </Modal>
     <!-- 提示框 -->
    <tip :tip="tip" v-show="tipShow"></tip>
     <!-- 预加载 -->
    <page-load v-if="loading"></page-load>
  </div>
</template>

<script>
import { getTopic, getArtCates } from "../api/api";
import { Link_Url } from "../api/config";
import pageLoad from "../pageload/pageload";

export default {
  components: { pageLoad },
  data() {
    return {
      Link_Url: Link_Url, //logo登录地址
      modal1: false, //对话框
      // url: "http://auth.cz.365mooc.cn/",
      topicArr: {}, //存放专题信息，网站的logo
      searchInfo: "", //搜索内容绑定
      tabList: [], //保存栏目列表
      iscur: 0,
      tip: "",
      tipShow: false,
      userFlag: true, //用户名、登录显示隐藏
      name: "",
      loading: true //预加载
    };
  },
  mounted() {
    this._getTopic(); //logo
    this.signed();
  },
  created() {},
  methods: {
    jump() {
      location.href = "http://zsg.zhxy.czvtc.edu.cn/#/home/login";
      // this.$router.push({ path: "/home/login" });
    },
    //上传网站的logo
    _getTopic() {
      let logo = JSON.parse(sessionStorage.getItem("logo"));
      this.loading = true;
      if (logo == null) {
        let module = {
          sch_id: 1,
          topic_id: 7
        };
        getTopic(module)
          .then(res => {
            if (res.status && res.data) {
              sessionStorage.setItem("logo", JSON.stringify(res));
              this.topicArr = res.data;
              this._getArtCates(); //栏目获取
            } else {
              this.loading = false;
              this.tipCtr("暂无数据");
            }
          })
          .catch(() => {
            this.loading = false;
            this.tipCtr("未找到相关数据,请重新加载");
          });
      } else {
        this.topicArr = logo.data;
        this._getArtCates(); //栏目获取
      }
    },
    //栏目获取
    _getArtCates() {
      let module = {
        sch_id: 1,
        topic_id: 7
      };
      this.loading = false;
      getArtCates(module)
        .then(res => {
          if (res.status && res.data && res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].odx > 0 && res.data[i].odx < 5) {
                this.tabList.push(res.data[i]);
              }
            }
          } else {
            this.tipCtr("暂无数据");
          }
        })
        .catch(err => {
          this.tipCtr("未找到相关数据,请重新加载");
        });
    },
    // 搜索方法
    search(info) {
      if (info != "") {
        this.$router.push({ path: "/home/search/" + info });
        this.searchInfo = "";
      } else {
        this.tipCtr("请输入搜索关键字");
      }
    },
    // 推出事件
    getBack() {
      this.userFlag = true;
      this.$router.push("/home/index");
      sessionStorage.clear();
    },
    //提示框函数
    tipCtr(text) {
      this.tip = text;
      this.tipShow = true;
      setTimeout(() => {
        this.tipShow = false;
      }, 1200);
    },
    // 对话框
    ok() {
      this.getBack();
      this.modal1 = false;
    },
    cancel() {
      this.modal1 = false;
    },
    signed() {
      if (sessionStorage.getItem("INFO") !== null) {
        this.name = JSON.parse(
          this.global.Base64.decode(sessionStorage.getItem("INFO"))
        ).xm;
        this.userFlag = false;
      } else {
        this.userFlag = true;
      }
    }
  }
};
</script>

<style scoped>
.contain {
  height: 110px;
  box-shadow: 0 0 1px 0;
  background-color: white;
}

.inner {
  width: 1200px;
  margin: 0 auto;
  min-width: 1200px;
}
.top {
  height: 28px;
}
.login {
  right: 0;
  top: 12px;
  background: #80c6ee;
  padding: 5px 15px;
}
.login > span a:hover {
  cursor: pointer;
  color: red !important;
}

.login > span a {
  font-size: 14px;
  border-radius: 10px;
}
.login span a {
  color: #fff;
  font-size: 14px;
}
.logoi2 span {
  font-size: 14px;
}
.login button {
  width: 50px;
  height: 30px;
  border: none;
  background-color: #80c6ee;
  margin-left: 20px;
  text-align: center;
  cursor: pointer;
  color: #fff;
  font-size: 14px;
}

.bottom {
  margin-top: 30px;
  border-radius: 3px;
}
/* logo */
.logo {
  top: -30px;
  left: 0;
}
/* 导航 */
.nav {
  margin-left: 420px;
}

.nav li {
  float: left;
  height: 40px;
  line-height: 40px;
  text-align: center;
  padding: 0 12px;
  color: #3a5ae1;
  cursor: pointer;
}

.nav li:hover {
  color: #80c6ee;
}

.nav li a {
  font-size: 16px;
}

.search {
  width: 320px;
  height: 34px;
  right: 0;
  top: 0;
}

.search input {
  border: 2px solid #80c6ee;
  text-indent: 15px;
  height: 34px;
  border-right: none;
  width: 286px;
  color: #999;
}

.search span {
  top: 0;
  right: 0;
  width: 34px;
  height: 34px;
  text-align: center;
  line-height: 34px;
  background-color: #80c6ee;
  color: #fff;
  cursor: pointer;
}

.router-link-active {
  color: #80c6ee;
}

.icon-sousuo {
  font-size: 14px !important;
}
.jump {
  cursor: pointer;
}
.jump:hover {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/headComp.vue